<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import service from '../../../../domain/leiloes/services'
  import BtnStatus from './BtnStatus.vue'
  import BtnStatusConfirmar from './ConfirmStatus'

  export default {
    components: {
      BtnStatus,
      BtnStatusConfirmar
    },
    nome: 'monitor-voltar-lote',
    directives: {mask},
    data () {
      return {
        pendencias: null,
        comitentes: null,
        pendenciasVisualizadas: []
      }
    },
    computed: {
      pendenciasFiltradas () {
        if (!this.pendencias) {
          return null
        }
        return this.pendencias.filter(p => !this.pendenciasVisualizadas.includes(p.id))
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos as informações iniciais')
      service.pendenciasVoltarLoteComitentes(this.$route.params.leilao)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.comitentes = response.data
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
      this.$interval = setInterval(() => {
        this.load()
      }, 10000)
      this.load()
    },
    beforeDestroy () {
      window.clearInterval(this.$interval)
    },
    deactivated () {
      window.clearInterval(this.$interval)
      this.$destroy() // no keep-alive
    },
    watch: {},
    methods: {
      load () {
        service.pendenciasVoltarLoteMonitor(this.$route.params.leilao)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.pendencias = response.data
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      },
      aceitar (id, p) {
        let confirmar = confirm('Você tem certeza que deseja aprovar a volta deste lote? Um lance será processado em nome do arrematante.')
        if (!confirmar) {
          return
        }
        this.$loaderOverlay.open().message('Processando pedido')
        service.aceitaVoltarLoteMonitor(id)
          .then((response) => {
            this.$loaderOverlay.hide()
            p.aceito = true
            alert('Solicitação aceita e lance processado com sucesso!')
            // this.visualizar(p)
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            alert(response.data.errors)
            console.log(response)
          })
      },
      visualizar (p) {
        this.pendenciasVisualizadas.push(p.id)
      },
      alteraPermissao (comitente) {
        this.$nextTick(() => {
          console.log('Alterando permissão', comitente)
          service.pendenciasVoltarLoteComitentesAlterar(comitente.id, comitente)
            .then((response) => {
            })
            .catch((response) => {
              console.log(response)
            })
        })
      }
    }
  }
</script>

<template>
  <div>
    <div class="wrapper-md">
      <div class="row wrapper-md" v-if="comitentes">
        Permitir voltar lote:<br><br>
        <span v-for="comitente in comitentes" :key="'comitente-' + comitente.id" style="display: flex; align-items: center">
          <label class="i-switch bg-success m-t-xs m-r">
                    <input type="checkbox" v-model="comitente.permitirVoltaLote" @change="alteraPermissao(comitente)">
                    <i></i>
                  </label> {{comitente.nome}}
        </span>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-6 hover-items" v-for="p in pendenciasFiltradas">
          <div class="panel wrapper">
            <h1 class="m-t-none">Lote {{ p.lote.numero }}</h1>
            <h4 class="m-t-none">{{ p.arrematante.apelido }}</h4>
            <h4 class="m-t-none">{{ p.arrematante.pessoa.nome }}</h4>
            <a v-if="!p.aceito" class="btn btn-success" @click="aceitar(p.id, p)"><i class="fa fa-check m-r-xs"></i> Aceitar</a>
            <div v-else class="font-bold btn btn-black">Aceito</div>
            <a class="btn btn-primary" @click="visualizar(p)"><i class="fa fa-eye m-r-xs"></i> Ocultar</a>
          </div>
        </div>
      </div>
      <div v-if="!pendencias || pendenciasFiltradas.length === 0">
        Nenhuma interação até o momento
      </div>
      <div class="m-t" v-if="pendencias && pendencias.length > 0 && pendencias.length !== pendenciasFiltradas.length">
        <div class="m-b-xs">Você ocultou algumas pendencias por tê-las visualizado.</div>
        <a class="btn btn-primary" @click="pendenciasVisualizadas = []">Reativar pendencias ocultadas</a>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// MonitorVoltarLote.vue?088809e0